<script setup lang="ts">
import Price from '../common/price.vue';
import BestPrice from '../common/best-price.vue';
import Installments from '../common/installments.vue';
import Banners from '../common/banners.vue';
import Delivery from '../common/delivery.vue';
import type { IBadge } from '../../models/badge';
import type { IInstallment } from '../../models/installment';
import type { IBanner } from '../../models/banner';
import type { ProductPageQuery } from '@/shared/apollo-api/__generated__/types';
import BnplButton from '../common/bnpl-button/bnpl-button.vue';

interface Props {
  sellPrice: number;
  fullPrice?: number;
  badges?: IBadge[];
  isBestPrice?: boolean;
  installments: IInstallment[];
  banners: IBanner[] | null;
  discountTimer?: NonNullable<ProductPageQuery['product']['skuList'][0]['discountTimer']>;
  available: number;
}

withDefaults(defineProps<Props>(), {
  fullPrice: undefined,
  badges: () => [],
  isBestPrice: false,
  discountTimer: undefined,
});
</script>

<template>
  <div class="price-set">
    <price
      :sellPrice="sellPrice"
      :fullPrice="fullPrice"
      :badges="badges"
      :discount-timer="discountTimer"
      showBanners
    />
    <best-price v-if="isBestPrice" />
    <installments v-if="installments && installments.length" :installments="installments" />
    <bnpl-button />
    <banners :banners="banners" />
    <Delivery v-if="available > 0" style="margin-top: 30px" />
  </div>
</template>
<style lang="stylus" scoped>
.price-set
  height max-content
  .best-price
    margin-top 16px
    padding-bottom 4px
  .installments
    margin-top 16px
  .banners
    margin-top 16px
</style>
